import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";

import { ACTIONS } from "app/app.constants";
import { getSummarizedDataStatesFromState } from "app/app.selectors";
import { getCollectionsByCourse } from "features/competence.actions";
import CourseSkillCollectionBasePage from "features/components/CourseSkillCollectionBasePage";

class CourseCollectionContainer extends PureComponent {
  componentDidMount() {
    const { dispatchGetCollections, courseId } = this.props;

    dispatchGetCollections(courseId);
  }

  getOptionHighlighted = option => {
    const { courseId } = this.props;

    return option && option.get("courseId")
      ? option.get("courseId").toString() === courseId.toString()
      : false;
  };

  render() {
    const { dataState, breadcrumb } = this.props;

    return (
      <CourseSkillCollectionBasePage
        title={breadcrumb}
        dataState={dataState}
        getOptionHighlighted={this.getOptionHighlighted}
        noResultsMessage="This course is not part of any collections"
      />
    );
  }
}

export default compose(
  connect(
    state => ({
      dataState: getSummarizedDataStatesFromState(
        state,
        ACTIONS.GET_COURSE,
        ACTIONS.GET_COLLECTIONS,
        ACTIONS.GET_COLLECTION_MATRIX,
      ),
    }),
    {
      dispatchGetCollections: getCollectionsByCourse,
    },
  ),
)(CourseCollectionContainer);
